import * as API from "@/services/API";

export default {
  getMain(Id) {
    return API.apiClient.get(`/npBackPh/${Id}`);
  },
  getMains() {
    return API.apiClient.get(`/npBackPh/`);
  },
  postMain(payload) {
    return API.apiClient.post(`/npBackPh/`, payload);
  },
  updateMain(Id, payload) {
    return API.apiClient.put(`/npBackPh/${Id}`, payload);
  },
  deleteMain(Id) {
    return API.apiClient.delete(`/npBackPh/${Id}`);
  },
};
